import script from "./CreateFlyer.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateFlyer.vue?vue&type=script&setup=true&lang=js"

import "./CreateFlyer.vue?vue&type=style&index=0&id=26204d2d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26204d2d"]])

export default __exports__